import api, { Paginated } from '.'
import { IBaseBodyComment, IPaginateComment } from './interfaces/IComment'
import { IBaseCommentRO } from './interfaces/IComment'
import { IFan } from './interfaces/IFan'
import { IFanQna } from './interfaces/IFanQna'

export const FanQnaApi = (accessToken?: string) => ({
  questions: async (params: IFan.FindQuestions) => {
    const res = await api.get<IFan.FindQuestionsRO>('/fan-qna/list/questions', {
      params,
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  question: async (id: number) => {
    const res = await api.get<IFanQna.IQuestionRO>(`/fan-qna/${id}/question`)

    return res.data
  },

  questionList: async (username: string) => {
    const res = await api.get<IFanQna.IQuestionListRO[]>(
      `/fan-qna/${username}/question-list`,
    )

    return res.data
  },

  answers: async (params: IFanQna.IAnswers) => {
    const res = await api.get<IFanQna.IAnswerPaginateRO>(
      `/fan-qna/list/answers`,
      {
        params,
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )

    return res.data
  },

  answer: async (id: number) => {
    const res = await api.get<IFanQna.IAnswerRO>(`/fan-qna/${id}/answer`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  createAnswer: async (body: IFanQna.IAnswerCreate) => {
    const res = await api.post<number>('/fan-qna/answer', body, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  updateAnswer: async (id: number, body: IFanQna.IAnswerUpdate) => {
    const res = await api.patch<number>(`/fan-qna/answer/${id}`, body, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  like: async (id: number) => {
    const res = await api.post<boolean>(`/fan-qna/answer/${id}/like`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  save: async (id: number) => {
    const res = await api.post<boolean>(`/fan-qna/answer/${id}/bookmark`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  delete: async (id: number) => {
    const res = await api.delete<number>(`/fan-qna/answer/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return res.data
  },

  comments: async (id: number, params: IPaginateComment) => {
    const res = await api.get<Paginated<IBaseCommentRO>>(
      `/fan-qna-comment/${id}`,
      {
        params,
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )

    return res.data
  },

  createComment: async (answerId: number, body: IBaseBodyComment) => {
    const res = await api.post<IBaseCommentRO>(
      `/fan-qna-comment/${answerId}`,
      body,
    )
    return res.data
  },

  likeComment: async (commentId: number) => {
    const res = await api.post<boolean>(`/fan-qna-comment/${commentId}/like`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  deleteComment: async (commentId: number) => {
    const res = await api.delete<boolean>(`/fan-qna-comment/${commentId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  updateComment: async (commentId: number, body: IBaseBodyComment) => {
    const res = await api.patch<IBaseCommentRO>(
      `/fan-qna-comment/${commentId}`,
      body,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
    return res.data
  },
})
